import {
  fetchLineTypes,
  fetchLineList,
  fetchStationList,
  fetchStationPosition,
  fetchAllocList,
} from "@/api/line";

export default {
  async FETCH_LINE_TYPES({ commit }, payload) {
    const response = await fetchLineTypes(payload);
    if (response) {
      commit("FETCH_LINE_TYPES", response.data.data);
    }
  },

  async FETCH_LINE_LIST(_context, payload) {
    const response = await fetchLineList(payload);
    if (response) {
      return response.data.data;
    }
  },

  async FETCH_STATION_LIST(_context, payload) {
    const response = await fetchStationList(payload);
    if (response) {
      return response.data.data;
    }
  },

  async FETCH_STATION_POSITION(_context, payload) {
    const response = await fetchStationPosition(payload);
    if (response) {
      return response.data.data;
    }
  },

  async FETCH_ALLOC_LIST(_context, payload) {
    const response = await fetchAllocList(payload);
    if (response) {
      return response.data.data;
    }
  },

  async SET_HAS_ASSIGNED_SEAT_LINE({ commit }, payload) {
    commit("SET_HAS_ASSIGNED_SEAT_LINE", payload);
  },
};
